import { render, staticRenderFns } from "./ExpandableItemContrats.vue?vue&type=template&id=2397b6fd&scoped=true&"
import script from "./ExpandableItemContrats.vue?vue&type=script&lang=js&"
export * from "./ExpandableItemContrats.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItemContrats.vue?vue&type=style&index=0&id=2397b6fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397b6fd",
  null
  
)

export default component.exports